const LABS_GRID_COLUMNS = "300px 1fr";
const LABS_SECTION_CODE = "SLAB";
const LABS_DATE_TIME_QCODE = `C001x${LABS_SECTION_CODE}Q001A001`;

export { LABS_DATE_TIME_QCODE, LABS_GRID_COLUMNS, LABS_SECTION_CODE };
